import React, { ReactElement, useEffect, useState } from 'react';
import { Galleria } from 'primereact/galleria';

import { Property } from '../../shared/schema/PropertySchema';
import { uploadedImageDir } from '../../utils/configs';

interface PropertiesLightboxProps {
  property: Property;
  onClose: () => void;
}

const PropertiesLightbox = (props: PropertiesLightboxProps): ReactElement => {
  const { property, onClose } = props;

  const [activeIndex, setActiveIndex] = useState(0);
  const [galleryRef, setGalleryRef] = useState(null);

  useEffect(() => {
    if (property && galleryRef) {
      galleryRef.show();
    }
  }, [property, galleryRef]);

  const itemTemplate = (img) => (
    <img
      src={`${uploadedImageDir}/${img.path}`}
      alt={img.path}
      style={{ width: '100%', display: 'block' }}
    />
  );

  return (
    <>
      <Galleria
        ref={(el) => {
          setGalleryRef(el);
        }}
        value={property.images}
        numVisible={7}
        style={{ maxWidth: '850px' }}
        activeIndex={activeIndex}
        onItemChange={(e) => setActiveIndex(e.index)}
        circular
        fullScreen
        showItemNavigators
        showThumbnails={false}
        item={itemTemplate}
        onHide={onClose}
      />
    </>
  );
};

export default PropertiesLightbox;
